import { PartnerWithCTrees } from "@components";
import { Hero, Features, News, } from "./components";

export default function ProductTemplate(props) {
    const { constants, product } = props;
    return (
        <div className="flex flex-col items-center">
            <Hero props={constants.hero} />
            <Features props={constants.features} />
            <PartnerWithCTrees />
            <News tag={product} />
            {/* <FAQ props={constants.questionList} /> */}
        </div>
    );
}
